import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import MUIDataTable from 'mui-datatables';

export default function UsersTable({ data, onRowClick }) {
  const columns = [
    {
      label: 'ID',
      name: 'id',
    },
    {
      label: 'Email',
      name: 'email',
    },
    {
      label: 'Created',
      name: 'createdAt',
    },
  ];

  const options = {
    filter: false,
    print: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    viewColumns: false,
    onRowClick: rowData => onRowClick(rowData[0]),
  };

  return (
    <Paper>
      <MUIDataTable columns={columns} data={data} title="Users" options={options} />
    </Paper>
  );
}

UsersTable.defaultProps = {
  onRowClick: () => {},
};

UsersTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      email: PropTypes.string,
      id: PropTypes.number,
    })
  ).isRequired,
  onRowClick: PropTypes.func,
};
